import { Component } from '@angular/core';
import { Target } from '@dekra-ds/angular';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  protected readonly Target = Target;
}
